import { useEffect, useState } from 'react';

import { useHttp } from '../../hooks/network';
import { useTranslation } from '../../hooks/translation';
import AppContainer from '../AppContainer/AppContainer';
import AppImage from '../AppImage';

import styles from './AppClients.module.scss';

export default function AppClients() {
  const { translate } = useTranslation();

  // partners state
  const [partners, setPartners] = useState(null);
  const fetchPartners = async () => {
    // eslint-disable-next-line
    const { request } = useHttp({});
    const { data } = await request({
      url: '/partners',
      params: {},
    });

    setPartners(data);
  };

  useEffect(() => {
    // eslint-disable-next-line
    fetchPartners();
  }, []);

  return (
    <section className={styles.AppClients}>
      <AppContainer>
        <div className={styles.AppClients__Wrapper}>
          <h4>{translate('some_of_our_clients')}</h4>
          <div className={styles.AppClients__List}>
            {partners?.data.map((el, index) => (
              <figure key={index} className={styles.AppClients__List__Item}>
                <AppImage objectFit="contain" src={el.image.url} alt={el.image.title} />
              </figure>
            ))}
          </div>
        </div>
      </AppContainer>
    </section>
  );
}
